import { render, staticRenderFns } from "./Carglass.vue?vue&type=template&id=2bdbc10b&scoped=true&"
var script = {}
import style0 from "./Carglass.vue?vue&type=style&index=0&id=2bdbc10b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdbc10b",
  null
  
)

export default component.exports